<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      color="secondary"
      style="z-index: 3"
      height="100%"
      width=240
      :absolute="$vuetify.breakpoint.mdAndUp"
      :expand-on-hover="expand"
      :mobile-breakpoint="960"
      :mini-variant="expand"
      dark
      app
    >
      <!-- NOMBRE DE USUARIO -->
      <v-list class="py-0">
        <v-list-item class="px-2 text-left">
          <v-list-item-avatar
            style="cursor: default"
            :color="$store.state.color_perfil"
          >
            <div style="font-size:22px">
              {{ $store.state.username.substring(0, 1) }}
            </div>
          </v-list-item-avatar>
          <div>
            <v-list-item-title style="cursor: default;">
              {{ $store.state.username }}
            </v-list-item-title>
            <v-list-item-subtitle class="caption mt-1" style="cursor: default;">
              <v-icon
                color="success"
                class="mr-1"
                x-small
              >
                fas fa-circle
              </v-icon>
              Online
            </v-list-item-subtitle>
          </div>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <!-- MENU -->
      <v-list
        class="text-left pa-2"
        dense
        nav
      >
        <template v-for="(item, index) in $store.state.menu">
          <navigation-menu-branch
            v-if="item"
            :key="'m-' + index"
            :item="item"
            :depth="0"
            @subir_vista="$emit('subir_vista')"
            @change_size="$emit('change_size', $event)"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <AppBar
      :p_expand.sync="expand"
      :p_drawer.sync="drawer"
    />
  </div>
</template>

<script>
import AppBar from './AppBar'
import NavigationMenuBranch from './components/NavigationMenuBranch.vue'

export default {
  data () {
    return {
      expand: false,
      drawer: true
    }
  },
  created () {
    this.$store.state.menu_expand = !this.expand
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false
    }
  },
  components: {
    AppBar,
    NavigationMenuBranch
  },
  watch: {
    expand (val) {
      this.$store.state.menu_expand = !val
    },
    '$vuetify.breakpoint.smAndDown' (val) {
      if (val) {
        this.expand = false
        this.drawer = false
      } else {
        this.expand = false
        this.drawer = true
      }
    }
  }
}
</script>